import { render, staticRenderFns } from "./warehousingDetail.vue?vue&type=template&id=b021e04a&"
import script from "./warehousingDetail.vue?vue&type=script&lang=js&"
export * from "./warehousingDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b021e04a')) {
      api.createRecord('b021e04a', component.options)
    } else {
      api.reload('b021e04a', component.options)
    }
    module.hot.accept("./warehousingDetail.vue?vue&type=template&id=b021e04a&", function () {
      api.rerender('b021e04a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/OMS/components/Warehousing/warehousingDetail.vue"
export default component.exports